import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <footer className="app-footer">
                <span className="ml-auto">© 2020 <a href="/">Monstyr</a></span>
            </footer>
        );
    }
}

export default Footer;